import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'
import CountriesRequest from 'app/requests/Country.requests'
import {
    Country,
} from '../Countries.types'

const useGetCountry = (id, keepPreviousData = true) => {
    return useRequest<Country>({
        key: RequestKeys.getCountry,
        params: {
            id,
        },
        requestFunc: RequestFn.getEntity(CountriesRequest.get),
        enabled: Boolean(id),
        keepPreviousData,
    })
}

export default useGetCountry
